<template>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" append-to-body width="95%" :before-close="closeDialog">
        <div>
            <div style="font-weight: 700; font-size: 20px; text-align: center; margin-bottom: 20px">
                添加{{ data.type == '0' ? '黑' : '白' }}名单模式
            </div>
            <div class="handle-box-search">
                 <div class="handle-box">
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">订单模式名称:</span>
                            <!-- 搜索订单模式名称 -->
                            <el-input
                                v-model="search_data.name"
                                placeholder="请输入订单模式名称"
                                class="handle-input mr10"
                                @keyup.enter.native="searchOrderModeLists"
                            ></el-input>
                        </el-col>
                    </el-row>
                </div>

                <el-button type="primary" icon="el-icon-search" @click="searchOrderModeLists">搜索</el-button>
                <el-button type="primary" @click="addList">添加</el-button>
            </div>
        </div>
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="id" label="订单模式ID" min-width="100"> </el-table-column>

            <el-table-column prop="name" label="订单模式名称" min-width="100"> </el-table-column>

        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
let _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.search_data.driver_code = _this.data.code;
            _this.submit_data.driver_code = _this.data.code;
            _this.submit_data.type = _this.data.type;
            _this.search_data.type = _this.data.type;

            _this.searchOrderModeLists();
        }
    },
    created() {
        _this = this;
    },
    data() {
        return {
            show: false,

            search_data: {
                page: 1,
                limit: 10,
                status: '',
                name: ''
            },
            submit_data: {
                driver_code: '',
                order_mode_code_array: [],
                type: ''
            },


            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },

            tableData: [],
            result_data: {}
        };
    },
    methods: {
        // 全选或多选
        handleSelectionChange(val) {
            console.log(val, 'val');

            var datalist = [];
            for (var i in val) {
                datalist.push(val[i].order_mode.order_mode_code);
            }

            _this.submit_data.order_mode_code_array = datalist;
        },
        addList() {
            if(_this.submit_data.order_mode_code_array.length==0) {
                this.$message.error("请勾选要添加的订单模式");
                return;
            }
            _this
                .$post('/driver_blacklist/addDriverModes',_this.submit_data)
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.searchOrderModeLists();
                    _this.closeDialog();
                    _this.$emit('onSubmit');
                })
                .catch((err) => {});
        },



        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.tableData = [];
            _this.result_data= {};
            _this.search_data = {
                page: 1,
                limit: 10,
                status: '',
                name: ''
            };
        },


        orderModeLists() {
            _this.$post('/order/orderModeLists', _this.search_data, _this.search_rules).then((res) => {
                _this.result_data = res;
                _this.tableData = res.data;
            });
        },

        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            // console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.orderModeLists();
        },
        searchOrderModeLists() {
            _this.search_data.page = 1;
            _this.orderModeLists();
        }
    }
};
</script>

<style scoped>
.pagination {
    text-align: right;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 160px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
